export default {
  SET_RESPONSE(state, { field, payload }) {
    state.response[field] = payload
  },
  SET_SERIALIZE(state, payload) {
    state.isSerialized = payload
  },
}
